import { BaseCommand } from './commands';
import { VodaDetailedBarUnbarCommand } from './VodaDetailedBarUnbarCommand';

export class VodaDetailedBarCommand extends VodaDetailedBarUnbarCommand {
  public definitionAlias: 'voda-detailed-bar' = 'voda-detailed-bar';
  constructor(command: BaseCommand) {
    super(command);
  }
}
